import { Component, Input, OnInit } from '@angular/core';
import { HospitalOptionCard } from '../../../../shared/model/prelogin/Hospital';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MonitoringService } from '../../../../shared/services/monitoring/monitoring-service';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { HospitalOptionCardComponent } from '../hospital-option-card/hospital-option-card.component';

@Component({
  selector: 'app-hospital-mobile',
  imports: [CommonModule, TranslateModule, MatProgressSpinnerModule, MatCardModule, MatButtonModule, HospitalOptionCardComponent],
  templateUrl: './hospital.component.html',
  styleUrl: './hospital.component.css'
})
export class HospitalComponent implements OnInit {
  @Input() locale: string | null = null;
  @Input() hospitalOptions: Array<HospitalOptionCard> = [];

  public title: string = 'TITLE';
  public description: string = 'DESCRIPTION';
  
  constructor(private translate: TranslateService, private monitoringService: MonitoringService) {
    this.translate.use(this.locale || 'en-US'); // Default to 'en-US' if no locale is provided
  }

  ngOnInit(): void {
    this.translate.get('HOSPITAL.TITLE').subscribe((translated: string) => {
      this.title = translated;
    });

    this.translate.get('HOSPITAL.DESCRIPTION').subscribe((translated: string) => {
      this.description = translated;
    });
  }
}